var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider"},[_c('div',{staticClass:"slider-item"},[_c('i',{staticClass:"el-icon-circle-close",on:{"click":_vm.closeSlider}}),_c('slide-verify',{attrs:{"l":42,"r":10,"w":310,"h":155,"imgs":_vm.imgs,"slider-text":_vm.text},on:{"success":_vm.onSuccess,"fail":_vm.onFail,"refresh":_vm.onRefresh}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }